import { render } from "./PdfRiskComment.vue?vue&type=template&id=4a017774&scoped=true"
import script from "./PdfRiskComment.vue?vue&type=script&lang=js"
export * from "./PdfRiskComment.vue?vue&type=script&lang=js"

import "./PdfRiskComment.vue?vue&type=style&index=0&id=4a017774&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a017774"]])

export default __exports__